class TableLoadMore {
    constructor(passedElement) {
        this.elem = passedElement;
        this.tbody = this.elem.querySelector('[data-table-body]');
        this.btn = this.elem.querySelector('[data-table-load-more]');
        this.btnWrap = this.btn ? this.btn.parentElement : null;
        this.perPage = parseInt(this.elem.getAttribute('data-load-more-count')) || 20;
    }

    init() {
        if (!this.tbody || !this.btn || !this.btnWrap) return;

        const rows = [...this.tbody.children];

        if (rows.length <= this.perPage) {
            this.btnWrap.classList.add('d-none');
            return;
        }

        rows.forEach((row, i) => {
            if (i >= this.perPage) row.classList.add('d-none');
        });

        this.btn.addEventListener('click', () => {
            const hidden = [...this.tbody.querySelectorAll('tr.d-none')];
            const toShow = hidden.slice(0, this.perPage);

            toShow.forEach((row) => row.classList.remove('d-none'));

            if (this.tbody.querySelectorAll('tr.d-none').length === 0) {
                this.btnWrap.classList.add('d-none');
            }
        });
    }
}

export default TableLoadMore;
